import { useEffect, useState } from 'react'

export default () => {
  const [mounted, updateMounted] = useState(false)

  useEffect(() => {
    updateMounted(true)
  }, [])

  return mounted
}